import { RouteObject } from 'react-router';

import { ProductAttributeDetails } from './AttributeDetails';
import { AttributeList } from './AttributeList';
import { BrandDetails } from './BrandsDetails';
import { BrandsList } from './BrandsList';
import { ProductCategoryList } from './CategoryList';
import { ProductCategoryDetails } from './ProductCategoryDetails';
import { ProductDetails } from './ProductDetails';
import { ProductLineDetails } from './ProductLinesDetails';
import { ProductLinesList } from './ProductLinesList';
import { ProductList } from './ProductList';
import { ProductSubtypeDetails } from './ProductSubtypeDetails';
import { ProductSubtypeList } from './ProductSubtypesList';
import { ProductTypeDetails } from './ProductTypeDetails';
import { ProductTypeList } from './ProductTypeList';

export const PRODUCT_ROUTES: RouteObject[] = [
    { index: true, Component: ProductList },
    { path: ':id', Component: ProductDetails },
    { path: 'brands', Component: BrandsList },
    { path: 'brands/:id', Component: BrandDetails },
    { path: 'product-lines', Component: ProductLinesList },
    { path: 'product-lines/:id', Component: ProductLineDetails },
    { path: 'attributes', Component: AttributeList },
    { path: 'attributes/:id', Component: ProductAttributeDetails },
    {
        path: 'categories',
        Component: ProductCategoryList,
    },
    {
        path: 'categories/:id',
        Component: ProductCategoryDetails,
    },
    {
        path: 'types',
        Component: ProductTypeList,
    },
    {
        path: 'types/:id',
        Component: ProductTypeDetails,
    },
    {
        path: 'subtypes',
        Component: ProductSubtypeList,
    },
    {
        path: 'subtypes/:id',
        Component: ProductSubtypeDetails,
    },
];
